/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionDataModel } from '../../models/patient-session-data-model';

export interface GetSessionEntriesForBehavior$Params {
  patientID?: number;
  behaviorID?: number;
}

export function GetSessionEntriesForBehavior(http: HttpClient, rootUrl: string, params?: GetSessionEntriesForBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSessionEntriesForBehavior.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('behaviorID', params.behaviorID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientSessionDataModel>>;
    })
  );
}

GetSessionEntriesForBehavior.PATH = '/api/Graph/GetSessionEntriesForBehavior';
